<div class="card">
    <slot></slot>
</div>

<style>
    .card{
        background-color: antiquewhite;
        border-radius: 18px;
        padding: 40px 50px;
        margin: 20px 0;
        position: relative;
        color:#202142;
    }
</style>